import { render, staticRenderFns } from "./messageManage.vue?vue&type=template&id=1153bd38&scoped=true"
import script from "./messageManage.vue?vue&type=script&lang=js"
export * from "./messageManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1153bd38",
  null
  
)

export default component.exports